export default __webpack_public_path__ + "static/media/logoatual.38cd813f.png";